import Cookies from 'js-cookie'

import { logoutGuruToken } from 'src/auth'
import { SESSION } from 'src/constant'

/** Revokes the guru token, then drops the local session. Awaited so a redirect can't cancel it. */
export async function clearGuruSession(): Promise<void> {
  const rawSession = Cookies.get(SESSION.USER_SESSION)

  if (rawSession) {
    try {
      const { guruToken } = JSON.parse(rawSession)
      if (guruToken) await logoutGuruToken(guruToken)
    } catch {
      // A broken cookie or a failed revoke must not block the cleanup.
    }
  }

  // No sessionStorage.clear(): the app stores nothing there, while the SDK keeps
  // its tokens and its prompt=none loop guard in it.
  Cookies.remove(SESSION.USER_SESSION)
}
